import { store } from "../store/store";
import { actions as commonActions } from "../store/commonRedux/actions";

const VERSION = 1;

export const DEFAULT_COLUMNS = 4;
export const COLUMN_OPTIONS = [2, 3, 4, 6];

const emptyState = () => ({
  version: VERSION,
  columns: DEFAULT_COLUMNS,
  items: [],
});

const scopeKey = (scope) => `${scope?.orgId ?? "no-org"}:${scope?.userId ?? "me"}`;

const sanitize = (state) => {
  if (!state || typeof state !== "object") return emptyState();

  const columns = COLUMN_OPTIONS.includes(state.columns)
    ? state.columns
    : DEFAULT_COLUMNS;

  const items = Array.isArray(state.items)
    ? state.items.filter((item) => item && item.id && item.label && item.url)
    : [];

  return { version: VERSION, columns, items };
};

const migrateLegacy = (scope) => {
  const legacyKey = `taskamoon:quick-access:${scopeKey(scope)}`;
  try {
    const raw = window.localStorage.getItem(legacyKey);
    if (!raw) return null;

    const migrated = sanitize(JSON.parse(raw));
    window.localStorage.removeItem(legacyKey);

    setTimeout(
      () =>
        store.dispatch(commonActions.setQuickAccess(scopeKey(scope), migrated)),
      0,
    );

    return migrated;
  } catch {
    return null;
  }
};

export function loadQuickAccess(scope) {
  const saved = store.getState().common.quickAccess?.[scopeKey(scope)];
  if (saved) return sanitize(saved);

  return migrateLegacy(scope) ?? emptyState();
}

export function saveQuickAccess(scope, state) {
  store.dispatch(
    commonActions.setQuickAccess(scopeKey(scope), sanitize(state)),
  );
}

export function makeShortcutId(sourceKey, value) {
  return `${sourceKey}:${value}`;
}
